import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ReviewThreatAssessmentSummaryComponent } from '../../../../components/review-content/review-threat-assessment-summary/review-threat-assessment-summary.component';

@Component({
  selector: 'threat-assessment-summary-submission',
  standalone: true,
  imports: [
    CommonModule,
    ReviewThreatAssessmentSummaryComponent
  ],
  templateUrl: './threat-assessment-summary-submission.component.html',
  styleUrl: './threat-assessment-summary-submission.component.css'
})
export class ThreatAssessmentSummarySubmissionComponent implements OnInit {

  @Input() threatAssessmentSummaryData: any;
  @Output() onSaveSection3 = new EventEmitter<any>();

  currentCaseId: string | null = null;

  ngOnInit(): void {
    if (this.threatAssessmentSummaryData) {
      this.currentCaseId = this.threatAssessmentSummaryData.case_id;
    }
  }

  submitThreatAssessmentSummary(): void {
    this.onSaveSection3.emit({});
  }
}
